module.exports = __webpack_public_path__ + "img/032.04947d51.png";